// import * as types from './type.js'
export default {
  activeIsPhone (state) {
    return state.isPhone
  }
}
